import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
  name: 'DateAgo',
  // pure: false
})
//Funciona con las traducciones
export class DateAgo implements PipeTransform {
  constructor() { }

  transform(value: any): string {
    if (!value) {
      return '';
    }

    const now = moment().local();

    const diff = now.diff(moment(value));
    const duration = moment.duration(diff)
    let days = duration.asDays();

      let hours = duration.asHours();
      let minutes = duration.asMinutes();
      let translation = '';

      if (days >= 1) {
        days = Math.ceil(days);
        const plural = days === 1 ? '' : 's';
        translation = `Desde hace ${days} día${plural}`;
      } else if (hours >= 1) {
        hours = Math.floor(hours);
        const plural = hours === 1 ? '' : 's';
        translation = `Desde hace ${hours} hora${plural}`;
      } else if (minutes >= 1) {
        minutes = Math.floor(minutes);
        const plural = minutes === 1 ? '' : 's';
        translation = `Desde hace ${minutes} minuto${plural}`;
      } else {
        translation = `Desde hace unos segundos`;
      }

      return translation;
    }


}